import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuExpandableTagsComponent } from '@shared/ui-components/au-expandable-tags/au-expandable-tags.component';

@NgModule({
	imports: [CommonModule, MatTooltipModule, AuExpandableTagsComponent],
	exports: [AuExpandableTagsComponent],
})
export class AuExpandableTagsModule {}
